import React, { useEffect }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import MemberList from 'components/Agile/member/memberList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import MemberAdd from 'components/Agile/member/memberMaintenance/memberAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchMembers,
    getAllMember,
    getUnselectedAllMember,
    handleMemberRequestClose,
    showMemberLoader,
    onAddMember,
    onFilterSelectedMember,
    onFilterMemberOptionSelect,
    onToggleMemberDrawer,
    updateSearchMember,
    filterMember,
} from 'actions/member';

const filterOptions = [
    {
        id: 1,
        name: 'All members',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred members',
        icon: 'zmdi-star'
    }
];

const Component = () => {
    const dispatch = useDispatch();
    const width = useSelector(state => state.settings.width);

    const loader = useSelector(state => state.members.loader);
    const alertMessage = useSelector(state => state.members.alertMessage);
    const showMessage = useSelector(state => state.members.showMessage);
    const noContentFoundMessage = useSelector(state => state.members.noContentFoundMessage);
    const drawerState = useSelector(state => state.members.drawerState);
    const member = useSelector(state => state.members.member);
    const searchMember = useSelector(state => state.members.searchMember);
    const memberList = useSelector(state => state.members.memberList);
    const selectedMembers = useSelector(state => state.members.selectedMembers);
    const addMemberState = useSelector(state => state.members.addMemberState);
    const selectedSectionId = useSelector(state => state.members.selectedSectionId);

    useEffect(() => {
        dispatch(showMemberLoader());
        dispatch(fetchMembers());
    }, []);

    const onAllMemberSelect = () => {
        const selectAll = selectedMembers < memberList.length;
        if (selectAll) {
            dispatch(getAllMember());
        } else {
            dispatch(getUnselectedAllMember());
        }
    };

    const updatingSearchMember = (evt) => {
        dispatch(updateSearchMember(evt.target.value));
        dispatch(filterMember(evt.target.value));
    };

    const memberRequestClose = () => {
        dispatch(handleMemberRequestClose());
    };

    const memberSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.members" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddMember())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="member.addMember" /></span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === selectedSectionId ? 'active' : ''} 
                                    onClick={() => dispatch(onFilterMemberOptionSelect(option))}>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleMemberDrawer())}
                        sidebar={memberSideBar(member)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {memberSideBar(member)}
                </div>
                <div className="module-box">
                    <div className="module-box-header">
                        <span className="icon-btn drawer-btn d-flex d-xl-none"
                            onClick={() => dispatch(onToggleMemberDrawer())}>
                            <i className="zmdi zmdi-menu" />
                        </span>
                        <AppModuleHeader
                            placeholder="Search member"
                            notification={false}
                            apps={false}
                            user={member}
                            onChange={(event) => updatingSearchMember(event)}
                            value={searchMember} />
                    </div>
                    <div className="module-box-content">
                        <div className="module-box-topbar">
                            <div className="form-control-checkbox d-flex">
                                <div className="form-checkbox">
                                    <input type="checkbox"
                                        checked={selectedMembers > 0}
                                        onChange={onAllMemberSelect} />
                                    <span className="check">
                                        <i className="zmdi zmdi-check zmdi-hc-lg" />
                                    </span>
                                </div>
                            </div>
                            <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                onClick={() => dispatch(onFilterSelectedMember())} >
                                <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                <span><IntlMessages id="label.filter.selected" /></span>
                            </Button>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                memberList && memberList.length > 0 ?
                                    <MemberList />
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>
                    </div>
                </div>
            </div>
            <MemberAdd
                open={addMemberState}
            />
            {showMessage && NotificationManager.success(alertMessage, memberRequestClose())}
            <NotificationContainer />
        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/member/component.js